export default class WindowUrlService {
  constructor() {

  }

  getWindowOriginUrlWithLanguage() {
    const windowOrigin = window.location.origin;

    if (window.location.pathname.split('/')[1].includes('es')) {
      return `${windowOrigin}/es`
    }

    return `${windowOrigin}/en`
  }
}
